// removed by extract-text-webpack-plugin
module.exports = {"docItem":"src-pages----document-module---docItem---25dnW","downloadButton":"src-pages----document-module---downloadButton---1QLaI","textLatin":"src-pages----document-module---textLatin---1nHvj","docTitle":"src-pages----document-module---docTitle---1g3Vr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/document.module.css
// module id = 286
// module chunks = 85387309168404